import { apiUrl, InitiateResponse, spawnErrorOverlay } from "../common";
import { fm } from "./fmWrapper";

export class PhotoPlayer {
    private playerElement: HTMLImageElement;

    public constructor(data: InitiateResponse, socket: HTMLDivElement) {
        this.playerElement = document.createElement("img");
        this.playerElement.src = `${apiUrl}/protected/play/${data.encryptedPlayPayload}/default`;
        this.playerElement.id = "photo-player";
        this.playerElement.addEventListener("error", (e) => {
            spawnErrorOverlay(
                JSON.stringify({
                    error: "Failed to load photo",
                    mimeType: data.mimeType,
                    details: e,
                })
            );
        });
        socket.appendChild(this.playerElement);

        fm.onPlayerReady();
    }
}
